module.exports = __webpack_public_path__ + "img/learning.8f809639.svg";